import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 1
const slug = 'underground-basement-excavation-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {
    const metaTags : MetaTagsProps =  {
        title: `Underground Basement Excavation Sydney | ${BUSINESS_NAME}`,
        description: "Specialist excavation for underground car parks and basements in residential and commercial developments.",
        keywords: "underground basement excavation sydney, basement excavation services, underground car park excavation, residential basement excavation, commercial basement excavation, site preparation, earthmoving, soil removal, foundation excavation, retaining wall excavation, waterproofing solutions, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Underground Basement Excavation',
    description: 'Specialist excavation for underground car parks and basements in residential and commercial developments.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
